import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import { IGeoAddressDetailsSchema } from '../../../node/repositories/countryside-search/entities/geo/GeoAddressDetailsSchema';
import { Link } from '../Link';
import * as styles from './index.css';

export interface ILinkAddressesProps {
  addressDetails: IGeoAddressDetailsSchema[];
}

export const LinkAddresses = ({ addressDetails }: ILinkAddressesProps) => {
  return (
    <>
      {addressDetails.reduce((prev, next, index) => {
        const link = next.seo?.url;

        const addressItem = link ? (
          <Link key={index} target="_blank" href={link}>
            <UIText2>
              <span className={styles['address-link']}>{next.fullName}</span>
            </UIText2>
          </Link>
        ) : (
          <UIText2 key={index}>{next.fullName}</UIText2>
        );

        return prev.length ? [...prev, ', ', addressItem] : [addressItem];
      }, [])}
    </>
  );
};
